import { ProductDetail } from './types';

const getProductDetailPlaceHolder = (): ProductDetail => {
    return {
        sku: '',
        name: '',
        sizes: [],
        numericPrice: 0,
        originalPrice: '',
        price: '',
        activeSimpleSKU: '',
        selectedSize: '',
        isAvailable: true,
        blackFriday: false,
        cyberMonday: false,
        imageUrl: '',
        deliveryInfo: null,
        innerDetails: {},
        isBisrEnabled: false,
        hasAddonProducts: false,
        seoData: {
            seoTitle: '',
            seoDescription: '',
            availableIn: {},
        },
        isBisrSubscribed: false,
        quantity: 1,
        assemblyServiceProduct: {
            templateLabel: '',
            label: '',
            selected: false,
        },
        fabricSampleCountries: [],
        isSustainable: false,
        isMoodImageFirstImage: false,
        hasProductLooks: false,
    };
};

export default getProductDetailPlaceHolder;
